import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["receiver", "provider"]

  perform() {
    this.applyValue()
    this.receiverTarget.setAttribute('readonly', true)
  }

  applyValue() {
    this.receiverTarget.setAttribute("value", this.providerTarget.selectedOptions.item(0).text)
    this.receiverTarget.value = this.providerTarget.selectedOptions.item(0).text
  }
}
